var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelexV2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1406 5.85938C12.3868 5.85938 11.7734 5.24605 11.7734 4.49219V0H4.78125C3.5966 0 2.63281 0.963789 2.63281 2.14844V17.8516C2.63281 19.0362 3.5966 20 4.78125 20H15.7188C16.9034 20 17.8672 19.0362 17.8672 17.8516V5.85938H13.1406ZM5.83594 14.0625H8.67656C9.00016 14.0625 9.2625 14.3248 9.2625 14.6484C9.2625 14.972 9.00016 15.2344 8.67656 15.2344H5.83594C5.51234 15.2344 5.25 14.972 5.25 14.6484C5.25 14.3248 5.51234 14.0625 5.83594 14.0625ZM5.25 11.5234C5.25 11.1998 5.51234 10.9375 5.83594 10.9375H14.4297C14.7533 10.9375 15.0156 11.1998 15.0156 11.5234C15.0156 11.847 14.7533 12.1094 14.4297 12.1094H5.83594C5.51234 12.1094 5.25 11.847 5.25 11.5234ZM14.4297 7.8125C14.7533 7.8125 15.0156 8.07484 15.0156 8.39844C15.0156 8.72203 14.7533 8.98438 14.4297 8.98438H5.83594C5.51234 8.98438 5.25 8.72203 5.25 8.39844C5.25 8.07484 5.51234 7.8125 5.83594 7.8125H14.4297Z",
    fill: "#1D4650"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9453 4.49137C12.9453 4.59906 13.0329 4.68668 13.1406 4.68668H17.606C17.4988 4.48879 17.3609 4.30703 17.1953 4.15027L13.4288 0.586914C13.2826 0.448633 13.1198 0.333281 12.9454 0.242188V4.49137H12.9453Z",
    fill: "#1D4650"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelexV2);
export default __webpack_public_path__ + "static/media/telexV2.5f623cc30e7826963ab3346ac56107b1.svg";
export { ForwardRef as ReactComponent };